import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import K8DigitalProgramCardV2 from './component'

export const K8DigitalProgramCardV2Container = props => {
  const {
    contentfulCourses,
    entryId,
    firstTimeMS,
    onComponentClick,
    ...otherProps
  } = props
  // FirstTimeClasses ref and handler
  const createCourseRef = useRef(null)

  // Handle create class button click
  const handleCreateClassClick = () => {
    if (createCourseRef.current) {
      const button = createCourseRef.current.querySelector(
        '[data-testid="button-create"]',
      )
      if (button) {
        button.click()
      }
    }
  }

  // Determine if we should show FirstTimeClasses
  const showFirstTimeClasses = firstTimeMS && entryId

  // Handle training click - check URL for grade level and redirect accordingly
  const onTrainingClick = () => {
    const url = window.location.href

    // Check if the URL contains grade level indicators
    if (url.includes('k-5') || url.includes('k5')) {
      onComponentClick('/product/elementary/trainings')
    } else if (url.includes('6-8') || url.includes('68')) {
      onComponentClick('/product/middle-school/trainings')
    } else {
      // Fallback - just log that no grade level was found
      console.log('No grade level found in URL for training redirect:', url)
    }
  }

  return (
    <K8DigitalProgramCardV2
      {...otherProps}
      contentfulCourses={contentfulCourses}
      createCourseRef={createCourseRef}
      handleCreateClassClick={handleCreateClassClick}
      onComponentClick={onComponentClick}
      onTrainingClick={onTrainingClick}
      showFirstTimeClasses={showFirstTimeClasses}
    />
  )
}

K8DigitalProgramCardV2Container.propTypes = {
  contentfulCourses: PropTypes.array,
  entryId: PropTypes.string,
  firstTimeMS: PropTypes.bool,
  onComponentClick: PropTypes.func,
}

export default K8DigitalProgramCardV2Container
